export default {
      id: "ic_arrow_right_dark-usage",
      viewBox: "0 0 10 15",
      url: "/" + "images/icons.3.109.2.svg#ic_arrow_right_dark-usage",
      toString: function () {
        return this.url;
      }
    }